'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["previewViewportWidth", "previewViewportHeight", "isSidebarExpanded", "updatePreviewViewportDimensions"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce } from 'underscore';
import { EDIT_PANE_CLASSNAME } from 'ContentEditorUI/constants/dom';
import { getIsSidebarExpanded } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getPreviewViewportWidth, getPreviewViewportHeight } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { updatePreviewViewportDimensions as updatePreviewViewportDimensionsAction } from 'ContentEditorUI/redux/actions/inpageActions';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isSidebarExpanded: getIsSidebarExpanded(state),
  previewViewportWidth: getPreviewViewportWidth(state),
  previewViewportHeight: getPreviewViewportHeight(state)
});
const mapDispatchToProps = {
  updatePreviewViewportDimensions: updatePreviewViewportDimensionsAction
};

// This is a higher-order-component so it can be the _parent_ of ContentViewContainer, because it needs to know
// when the edit pane has been fully mounted (and that is easier by making it a parent instead of passing
// `hasMounted={true}` to a child component)
const PreviewViewportSizeHOC = WrappedComponent => {
  var _class;
  const PreviewViewportSizeContainer = (_class = class PreviewViewportSizeContainer extends Component {
    constructor(props) {
      super(props);
      this.debouncedUpdatePreviewViewport = debounce(this.updatePreviewViewport.bind(this), 300);
    }
    componentDidMount() {
      this.editPane = document.getElementsByClassName(EDIT_PANE_CLASSNAME)[0];
      window.addEventListener('resize', this.debouncedUpdatePreviewViewport);
      this.debouncedUpdatePreviewViewport();
    }
    componentDidUpdate(prevProps) {
      const {
        isSidebarExpanded
      } = this.props;
      const sidebarChanged = prevProps.isSidebarExpanded !== isSidebarExpanded;
      if (sidebarChanged) {
        this.debouncedUpdatePreviewViewport();
      }
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedUpdatePreviewViewport);
    }
    updatePreviewViewport() {
      const {
        previewViewportWidth,
        previewViewportHeight,
        updatePreviewViewportDimensions
      } = this.props;
      if (this.editPane) {
        const {
          top,
          left,
          width,
          height
        } = this.editPane.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const newWidth = windowWidth - left;
        const newHeight = windowHeight - top;
        const isPreviewVisible = width !== 0;
        if (isPreviewVisible && (previewViewportWidth !== newWidth || previewViewportHeight !== newHeight)) {
          updatePreviewViewportDimensions({
            width,
            height
          });
        }
      }
    }
    render() {
      const _this$props = this.props,
        forwardedProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, forwardedProps));
    }
  }, _class.propTypes = {
    previewViewportWidth: PropTypes.number,
    previewViewportHeight: PropTypes.number,
    isSidebarExpanded: PropTypes.bool.isRequired,
    updatePreviewViewportDimensions: PropTypes.func.isRequired
  }, _class);
  const ConnectedPreviewViewportSizeContainer = connect(mapStateToProps, mapDispatchToProps)(PreviewViewportSizeContainer);
  return ConnectedPreviewViewportSizeContainer;
};
export default PreviewViewportSizeHOC;